import { EPromoOffersActionTypes } from '../../actions/promoOffers';
import { IPromoOffersState } from '../../types/promoOffersSelection';
import { TReduxActions } from '../../types/redux';

export const defaultState: IPromoOffersState = {
  isEnabled: false,
  listingUrl: 'https://cian.ru/',
  offersIds: [],
  offers: [],
};

export function promoOffersReducer(state: IPromoOffersState = defaultState, action: TReduxActions): IPromoOffersState {
  switch (action.type) {
    case EPromoOffersActionTypes.UpdateFavorite: {
      const { offerId, isFavorite } = action.payload;

      return {
        ...state,
        offers: state.offers.map(offer => (offer.offerId === offerId ? { ...offer, isFavorite } : offer)),
      };
    }
    case EPromoOffersActionTypes.SetOffers: {
      return {
        ...action.payload,
      };
    }
    default:
      return state;
  }
}
